import { DictionaryItemDto, DictionaryTypeDto } from '@/api/generated';
import { useGetAllDictionaries } from '@/api/requests/useGetAllDictionaries.util.ts';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import React, { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DictionariesContext,
  DictionariesContextProps,
  DictionariesDefaultValues,
} from './Dictionaries.context';

const mapDict = (dict: DictionaryItemDto): SelectSearchOptionModel<string> => ({
  code: dict.identifier?.code,
  label: dict.label?.value || '',
  value: dict.identifier?.id?.toString() || '',
});

export const DictionariesContextProvider: React.FC<PropsWithChildren> = props => {
  const { t } = useTranslation();
  const [groupedDictionaries, setGroupedDictionaries] = useState<DictionariesContextProps>({
    ...DictionariesDefaultValues,
  });

  const { dictionaries, isDictionariesError, isFetchingDictionariesTypes } =
    useGetAllDictionaries();

  useEffect(() => {
    if (dictionaries) {
      setGroupedDictionaries({
        [DictionaryTypeDto.Location]: dictionaries[DictionaryTypeDto.Location]?.map(mapDict) || [],
        [DictionaryTypeDto.Status]: dictionaries[DictionaryTypeDto.Status]?.map(mapDict) || [],
        [DictionaryTypeDto.TypeOfStudy]:
          dictionaries[DictionaryTypeDto.TypeOfStudy]?.map(mapDict) || [],
        [DictionaryTypeDto.UniversityName]:
          dictionaries[DictionaryTypeDto.UniversityName]?.map(mapDict) || [],
        [DictionaryTypeDto.YearOfStudy]:
          dictionaries[DictionaryTypeDto.YearOfStudy]?.map(mapDict) || [],
      });
    }
  }, [dictionaries]);

  const context: DictionariesContextProps = useMemo(() => {
    return {
      ...groupedDictionaries,
    };
  }, [groupedDictionaries]);

  if (isFetchingDictionariesTypes) {
    return <div>{t('components.loader.loading')}</div>;
  }

  if (isDictionariesError) {
    return <div>{t('utils.errors.unexpectedError')}</div>;
  }

  return (
    <>
      <DictionariesContext.Provider value={context}>{props.children}</DictionariesContext.Provider>
    </>
  );
};
